import {
  useMutation,
  useQuery,
  useQueryClient,
  useInfiniteQuery,
} from 'react-query';
import { useApi } from './api';

const baseUrl = '/designs';

// Get Design
export const useFetchDesign = (id) => {
  const api = useApi();
  const fetchDesign = async () => {
    const {
      data: { data },
    } = await api.get(`${baseUrl}/${id}`);

    return data;
  };

  return useQuery(['design', { id }], fetchDesign);
};

// Get Designs
export const useFetchDesigns = () => {
  const api = useApi();

  const limit = 40;

  const fetchDesigns = async (pageParam) => {
    let url = `/designs?limit=${limit}`;
    if (pageParam) {
      url = `${pageParam}&limit=${limit}`;
    }

    const { data } = await api.get(url);

    return data;
  };
  return useInfiniteQuery(['designs'], ({ pageParam }) => fetchDesigns(pageParam), {
    getNextPageParam: (lastPage) => {
      return lastPage?.links?.next;
    },
    refetchOnWindowFocus: false,
  });
};

export const useGenerateDesign = (reset = false) => {
  const api = useApi();

  const generateDesign = async ({ id, type }) => {
    let apiUrl = `designs/${id}/generate/pdf`;

    if (type === 'pdf-prev') {
      apiUrl = `designs/${id}/generate/preview-pdf`;
    } else if (type === 'png') {
      apiUrl = `designs/${id}/generate/png`;
    }

    const { data } = await api.post(apiUrl, { reset });

    return data;
  };

  return useMutation(generateDesign, {
    retry: (_, err) => {
      if (
        err?.response?.status &&
        (err?.response?.status !== 200 || err?.response?.status !== 201)
      ) {
        return false;
      }
      return 10;
    },
    retryDelay: 5000,
  });
};

// Add design
export const useAddDesign = async (design) => {
  const api = useApi();

  const { data } = await api.post(baseUrl, design);
  return data;
};

// Update design
export const useEditDesign = (id, filter) => {
  const queryClient = useQueryClient();
  const api = useApi();

  return useMutation(
    (details) => {
      let result;

      if (id && details) result = api.put(`${baseUrl}/${id}`, details);

      return result;
    },
    {
      onSuccess: (data) => {
        if (filter) {
          queryClient.setQueryData(['designs', { filters: filter }], () => {
            queryClient.invalidateQueries(['designs', { filters: filter }]);
          });
        } else {
          queryClient.setQueryData(['design', { id }], () => data.data.data);
        }
      },
    }
  );
};

// Fetch layers of Design
export const useFetchLayers = (id) => {
  const api = useApi();

  return useQuery(['layers', { id }], async () => {
    const {
      data: { data },
    } = await api.get(`${baseUrl}/${id}/layers`);

    return data;
  });
};
